import { useMaintenanceAndLockFlag } from '@queries/clientAdministration';
import { YesNoFlag } from '@common/constants/sharedConstants';
import type { UserCommands } from '@common/types/permissions';
import { useSelector } from 'react-redux';
import { userPermissionCommandsSelector } from '../store/selectors';

export const useIsClientLocked = (): boolean => {
  const { data: { lockFlag }, isLoading } = useMaintenanceAndLockFlag();
  const commands = useSelector(userPermissionCommandsSelector) as (UserCommands | undefined);
  return !commands?.canBypassClientLock && (isLoading || lockFlag === YesNoFlag.Y);
};
